import 'select2';

var selectSearch = {
	init: function() {

		if (typeof jQuery.fn.select2 === 'function') {
			jQuery('.select2-general, .select2-multiple').select2({
				theme: 'bootstrap-5'
			});
		}
	}
};

export default selectSearch;
